import {
  FileTextFill,
  CheckCircleFill,
  PeopleFill,
  PersonBadgeFill,
  ShieldFillCheck,
  ExclamationTriangleFill,
} from 'react-bootstrap-icons';

const SECTIONS = [
  {
    icon: <CheckCircleFill />,
    title: 'Agreement to Terms',
    body: (
      <>
        <p>These terms of service govern your access to the Paragon Conquer server and our services.</p>
        <p>By creating an account and playing the server, you agree to these terms and any future amendments made to this document.</p>
      </>
    ),
  },
  {
    icon: <PeopleFill />,
    title: 'Player Conduct',
    body: (
      <>
        <p>You may not use our server to do or share anything that violates these terms, our server rules, or other policies.</p>
        <ul>
          <li>Unlawful and fraudulent behaviour is prohibited.</li>
          <li>You agree not to expose minors using the service to any unsuitable content.</li>
          <li>You agree not to partake in any action that could be detrimental to the server or other players.</li>
        </ul>
      </>
    ),
  },
  {
    icon: <PersonBadgeFill />,
    title: 'Account Responsibility',
    body: (
      <>
        <p>The security of your account is in your hands. Account sharing is not supported by the server.</p>
        <p>If you are scammed or hacked as a result of a shared account, your case will be denied.</p>
      </>
    ),
  },
  {
    icon: <ShieldFillCheck />,
    title: 'Staff & Moderation',
    body: (
      <>
        <p>You agree that the staff of the server will not be held liable for content posted by other users. If you encounter offensive content, please report it through the correct avenues.</p>
        <p>Decisions made by the Paragon Conquer team on matters surrounding the server are final.</p>
      </>
    ),
  },
  {
    icon: <ExclamationTriangleFill />,
    title: 'Enforcement',
    body: (
      <p>If you are found to be acting against these rules, we reserve the right to remove your access to the server without prior notice or warning.</p>
    ),
  },
];

export function TermsOfService() {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="policy-hero-icon"><FileTextFill /></div>
        <h2>Terms of Service</h2>
        <p>Please read these terms carefully before playing Paragon Conquer.</p>
      </div>

      {SECTIONS.map((s, i) => (
        <div key={i} className="policy-section">
          <div className="policy-section-header">
            <span className="policy-section-icon">{s.icon}</span>
            <h5>{s.title}</h5>
          </div>
          <div className="policy-section-body">{s.body}</div>
        </div>
      ))}

      <div className="policy-note">
        <p>Paragon Conquer reserves the right to update these terms at any time. Continued use of the server constitutes acceptance of any changes.</p>
      </div>
    </div>
  );
}
